import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { UpdateUserAccountBody } from "@shared-kernel/application/ports/admin/admin-repository";

export interface UpdateUserAccountParams {
  userId: string;
  body: UpdateUserAccountBody;
}

export const updateUserAccount = createAsyncThunk<string, UpdateUserAccountParams, { extra: Partial<Dependencies> }>(
  "admin/users/updateAccount",
  async ({ userId, body }, { extra: { adminRepository } }) => {
    await adminRepository!.updateUserAccount(userId, body);
    return userId;
  },
);

export const resetUpdateUserAccount = createAction("admin/users/resetUpdateAccount");
